/* Applying one change to a list of tracker rows.
 *
 * Pure, and separate from the hook that receives it, because this is the part
 * that can be quietly wrong. A row appended in the wrong place, a soft delete
 * mistaken for an edit, or a hard delete that leaves the row on screen are all
 * bugs nobody notices until two people are looking at different numbers on a
 * call, which is the exact thing live editing was meant to prevent.
 *
 * The shapes come from Postgres: an insert and an update carry the whole new
 * row, and a delete carries only the primary key, which is all that is needed
 * to drop it.
 */
export function applyRowChange(rows, payload) {
  if (!rows) return rows;
  const { eventType, new: row, old } = payload ?? {};

  if (eventType === "DELETE") {
    if (!old?.id) return rows;
    return rows.filter((r) => r._id !== old.id);
  }

  if (!row?.id) return rows;

  /* A soft delete arrives as an update. It is still a removal. */
  if (row.deleted_at) return rows.filter((r) => r._id !== row.id);

  const next = { ...row.data, _id: row.id, _index: row.row_index };
  const at = rows.findIndex((r) => r._id === row.id);
  if (at >= 0) return rows.map((r, i) => (i === at ? next : r));

  /* A row somebody else added. It goes where its own index says, not on the
     end, so two people adding at once do not see different orders. */
  return [...rows, next].sort((a, b) => a._index - b._index);
}
